// extracted by mini-css-extract-plugin
export default {"view-controls":"lsf-view-controls","view-controls__label":"lsf-view-controls__label","view-controls_collapsed":"lsf-view-controls_collapsed","button":"lsf-button","button__icon":"lsf-button__icon","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630378875
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  